import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { SemiBold } from '../../components/UI/Text';
import TextField from '../../components/UI/TextField';
import Button from '../../components/UI/Button';
import { userApi } from '../../api/user';

const Container = styled.div`
	width: 80%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 50px;
`;

const FieldContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export default function FindId() {
	const [email, setEmail] = React.useState({
		email: ''
	});
	const navigate = useNavigate();

	const handleSubmit = (e) => {
		e.preventDefault();
		userApi.findUserId(email)
			.then((response) => {
				navigate('/popUp/find-id/result', { state: { id: response.id } });
			})
			.catch((error) => {
				alert('아이디를 찾을 수 없습니다. 입력하신 정보를 다시 확인해 주세요.');
			});
	};
	
  	return (
		<Container>
			<SemiBold size="24px">가입 시 사용한 이메일을 입력하세요.</SemiBold>
			<FieldContainer>
				<TextField type="text" $placeholder="이메일" onChange={(e) => setEmail({ email: e.target.value })}/>
			</FieldContainer>
			<Button buttonText="찾기" width="100%" height="60px" onClick={ handleSubmit }/>
		</Container>
  	)
}
